// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Sbck","content":"styles_content__1qz-H","title":"styles_title__3ZiyP","active":"styles_active__o1XXw","titleEN":"styles_titleEN__1BrCH"};